import React, {Fragment, useEffect, useRef, useState} from "react";
import {KoerberContainer} from "../../utils/styled/_grid.style";
import Button from "../Button/Button";
import DownloadForm from "../Forms/DownloadForm/DownloadForm";
import Loading from "../Loading/Loading";
import {KoerberContactFormOverlay} from "../ContactFormOverlay/ContactFormOverlay.style";
import {CAStates, Countries, USStates,} from "../Forms/DropdownContentLists.json";
import Icon from "../Icon/Icon";
import {colors} from "../../utils/styled/_variables.styled";
import {ContentType} from "./ContentType.style";
import {EmbeddedFormWrapper} from "../StickyForm/StickyForm.style";
import EmbedHtmlMarketo from "../Embed/EmbedHtmlMarketo";

const DownloadFormOverlay = (props) => {
  const {
    className,
    open,
    close,
    title,
    subtitle,
    text,
    marketingConsentText,
    buttonText,
    contentType,
    readingTime,
    category,
    triggerFocus,
    actionPath,
    useAnalytics,
    embedHtml,
    firstNameText,
    lastNameText,
    emailText,
    companyText,
    countryText,
    stateText,
    requiredFirstNameText,
    requiredLastNameText,
    requiredEmailText,
    requiredCompanyText,
    requiredCountry,
    requiredState,
    countryValues,
    usaStateValues,
    canadaStateValues,
    captchaConfig,
    pageLanguage
  } = props;

  const ref = useRef(null);
  const scrollRef = useRef(null);

  const [hasOverflow, setHasOverflow] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [showLeftGradient, setShowLeftGradient] = useState(false);
  const [showRightGradient, setShowRightGradient] = useState(true);
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (!ref?.current) return;
    handleResize();
    window.addEventListener("resize", handleResize);
    ref.current.addEventListener("scroll", handleScrollTabs);

    return () => {
      ref.current.removeEventListener("scroll", handleScrollTabs);
      window.removeEventListener("resize", handleResize);
    };
  }, [ref]);

  useEffect(() => {
    if (!scrollRef?.current) return;

    scrollRef.current.addEventListener("scroll", handleScrollOverlay);

    return () => {
      scrollRef.current.removeEventListener("scroll", handleScrollOverlay);
    };
  }, [scrollRef]);

  const handleCloseButton = () => {
    sessionStorage.clear();
    setShowLoading(false);
    close();
  };

  const handleResize = () => {
    if (ref.current) {
      const hasOverflow = ref.current.scrollWidth > ref.current.clientWidth;
      setHasOverflow(hasOverflow);
    }
  };

  const handleScrollOverlay = () => {
    setHasScrolled(scrollRef.current.scrollTop > 100);
  };

  const handleScrollTabs = () => {
    const scrollLeft = ref.current.scrollLeft;
    const scrollWidth = ref.current.scrollWidth;
    const clientWidth = ref.current.clientWidth;
    setShowLeftGradient(!!scrollLeft);
    setShowRightGradient(scrollLeft !== scrollWidth - clientWidth);
  };

  return (
    <>
      <KoerberContactFormOverlay
        className={`${hasScrolled ? "fixed" : ""} ${className}`}
        open={open}
        showLeftGradient={showLeftGradient}
        showRightGradient={showRightGradient}
        hasOverflow={hasOverflow}
      >
        <KoerberContainer>
          <Button
            className={"close"}
            onClick={() => handleCloseButton()}
            tertiary
            icon="close"
          />
          <section className="overlay-wrapper">
            <ContentType>
              {contentType && <p>{contentType}</p>}
              {readingTime && (
                <p>
                  <Icon color={colors.gray5} icon="eye-filled" /> {readingTime.includes('min') ? readingTime : `${readingTime} min`}
                </p>
              )}
            </ContentType>
            <h2 className="heading-2">{title || "How may we contact you?"}</h2>
            <span className="heading-5" style={{ paddingTop: "44px" }}>
              {subtitle}
            </span>
            <p style={{ marginTop: "8px" }} className="form__subtitle">
              {text ||
                "Körber can help you achieve a breakthrough in your supply chain. Tell us about your projects and we will be in touch shortly."}
            </p>
          </section>
          {embedHtml ? 
						<EmbeddedFormWrapper>
							<EmbedHtmlMarketo embedHtml={embedHtml}/>
						</EmbeddedFormWrapper>
						:
            <DownloadForm
              marketingConsentText={marketingConsentText}
              buttonText={buttonText}
              countryList={Countries}
              USStateList={USStates}
              showCheckbox={!!marketingConsentText}
              category={category}
              CAStateList={CAStates}
              LoadingWatcher={setShowLoading}
              triggerFocus={triggerFocus}
              actionPath={actionPath}
              useAnalytics={useAnalytics}
              firstNameText={firstNameText}
              lastNameText={lastNameText}
              emailText={emailText}
              companyText={companyText}
              countryText={countryText}
              stateText={stateText}
              countryValues={countryValues}
              usaStateValues={usaStateValues}
              canadaStateValues={canadaStateValues}
              requiredFirstNameText={requiredFirstNameText}
              requiredLastNameText={requiredLastNameText}
              requiredEmailText={requiredEmailText}
              requiredCompanyText={requiredCompanyText}
              requiredCountry={requiredCountry}
              captchaConfig={captchaConfig}
              requiredState={requiredState}
              pageLanguage={pageLanguage}
            />
          }
        </KoerberContainer>
      </KoerberContactFormOverlay>
      {showLoading && <Loading />}
    </>
  );
};

export default DownloadFormOverlay;
